import connectionsStore from "@mobx/store/connections";
import usePlaceID3 from "./usePlaceID";

export const useConnectionsActions3 = () => {
  const { placeID } = usePlaceID3(true);
  return placeID ? connectionsStore.getPlaceStore(placeID) : undefined;
}